// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-F":"G_shp2-detail-F__SdFJi"};